import { Permission } from '@fly/shared';
import { z } from 'zod';

export const generateTokenSchema = z.object({
  tokenName: z.string().min(1),
  expirationTime: z.string().min(1),
  permissions: z.enum(Object.values(Permission) as [string, ...string[]]),
});

export type GenerateTokenFormData = z.infer<typeof generateTokenSchema>;
